<template>
  <div class="points-table-page mt-4">
    <app-page-header
      title="Tabela de Pontos"
      subtitle="A validade dos pontos inicialmente definida, pode sofrer variações de acordo com campanhas ativas no mesmo período."
    ></app-page-header>

    <div class="container">
      <div class="listing">
        <div class="row search-fields">
          <b-field class="col-md-3 col-xm-12" label="Código">
            <b-input v-model="filters.ean_code" @input="loadPointsDebounced" />
          </b-field>

          <app-autocomplete
            class="col-md-3 col-xm-12"
            label="Campanha"
            placeholder="Selecionar"
            :searchFunction="searchCampaigns"
            :resouceIdFunction="searchCampaignById"
            v-model="filters.campaign_id"
            field="name"
            @selected="loadPoints"
          />

          <app-autocomplete
            class="col-md-3 col-xm-12"
            label="Produto"
            placeholder="Selecionar"
            :searchFunction="searchProducts"
            :resouceIdFunction="searchProductById"
            v-model="filters.product_id"
            field="name"
            @selected="loadPoints"
          />

          <b-field class="col-md-3 col-xm-12" label="Mês">
            <b-datepicker
              type="month"
              placeholder="Clique para selecionar..."
              icon="calendar-today"
              trap-focus
              v-model="filters.month"
              @input="loadPoints"
            />
          </b-field>
        </div>

        <div class="extracts-table">
          <b-table
            :data="data"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            aria-next-label="Próxima Página"
            aria-previous-label="Página Anterior"
            aria-page-label="Página"
            aria-current-label="Página Atual"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Período"
                >{{ props.row.campaign.start_at | date('DD/MM/YYYY') }} a
                {{
                  props.row.campaign.end_at | date('DD/MM/YYYY')
                }}</b-table-column
              >
              <b-table-column field="name" label="Campanha">{{
                props.row.campaign.name
              }}</b-table-column>
              <b-table-column field="name" label="Código EAN">{{
                props.row.product.ean_code
              }}</b-table-column>
              <b-table-column field="name" label="Produto">{{
                props.row.product.name
              }}</b-table-column>
              <b-table-column
                field="points"
                label="Pontos"
                class="points"
                numeric
                >{{ props.row.points | number }}</b-table-column
              >
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                  </p>
                  <p>Nenhum registro encontrado.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignPointsService from '@/services/campaign-points.service.js';
import CampaignService from '@/services/campaign.service.js';
import ProductService from '@/services/product.service.js';
import debounce from 'lodash/debounce';

export default {
  name: 'points-table-page',
  data: () => {
    return {
      isLoading: true,
      data: [],
      families: [],
      filters: {
        ean_code: null,
        month: null,
        product_id: null,
        campaign_id: null,
      },
      page: 1,
      perPage: 10,
      total: null,
    };
  },
  methods: {
    loadPointsDebounced: debounce(function () {
      this.loadPoints();
    }, 400),
    loadPoints() {
      CampaignPointsService.getForClient({
        ...this.filters,
        page: this.page,
        perPage: this.perPage,
      })
        .then(({ data }) => {
          this.data = data.data;
          this.total = data.total;
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.loadPoints();
    },
    searchCampaigns: (term) => CampaignService.search({ term }),
    searchCampaignById: CampaignService.getId,
    searchProducts: (term) => ProductService.search({ term, paginate: false }),
    searchProductById: ProductService.getId,
  },

  mounted() {
    this.loadPoints();
  },
};
</script>

<style lang="scss" scoped>
.search-fields {
  background: var(--color-light-grey);
  margin-top: 4em;
  padding: 1em 2em;
  border-radius: 1em;
}

#no-results {
  margin-top: 2em;
}

h1 {
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
}

.points {
  color: var(--color-primary);
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
}

@media (max-width: 992px) {
  .search-fields {
    margin: 0;
    padding: 1em;
    margin-bottom: 1em;
  }
}
</style>
